import { useEffect } from "react";
import * as Sentry from "@sentry/react";

import { installBodyPointerEventsGuard } from "@/utils/bodyPointerEvents";

/**
 * Keeps a stranded `pointer-events: none` from leaving the app unclickable.
 * See `@/utils/bodyPointerEvents` for what leaves it behind and why hover is
 * the trigger.
 *
 * Every recovery is reported to Sentry. We could not reproduce MSMS-53 against
 * the affected org, so the report is how we learn whether this is really what
 * was happening — a silent fix would leave that open.
 */
export function useBodyPointerEventsGuard(): void {
  useEffect(
    () =>
      installBodyPointerEventsGuard(() => {
        Sentry.captureMessage(
          "Recovered a stuck pointer-events:none on <body>",
          "warning"
        );
      }),
    []
  );
}

export default useBodyPointerEventsGuard;